<template>
<div class="chapter">
<div class="inner_page">
<p class="C2816"><span id="page_vii">Abbreviations </span></p>
<table>
<tbody><tr><td valign="top">ACGME </td><td valign="top">Accreditation Council for Graduate Medical Education (United States) </td></tr>
<tr><td valign="top">ACLU </td><td valign="top">American Civil Liberties Union </td></tr>
<tr><td valign="top">ACOG </td><td valign="top">American College of Obstetricians and Gynecologists </td></tr>
<tr><td valign="top">ALI </td><td valign="top">American Law Institute </td></tr>
<tr><td valign="top">ALRA </td><td valign="top">Abortion Law Reform Association (Britain) </td></tr>
<tr><td valign="top">AMA </td><td valign="top">American Medical Association </td></tr>
<tr><td valign="top">AMCAL </td><td valign="top">Association for the Modernization of Canadian Abortion Laws </td></tr>
<tr><td valign="top">AMPAC </td><td valign="top">American Medical Political Action Committee </td></tr>
<tr><td valign="top">ASA </td><td valign="top">Association for the Study of Abortion (United States) </td></tr>
<tr><td valign="top">BMA </td><td valign="top">British Medical Association </td></tr>
<tr><td valign="top">BPAS </td><td valign="top">Birmingham Pregnancy Advisory Service (later, British Pregnancy Advisory Service) </td></tr>
<tr><td valign="top">CARAL </td><td valign="top">Canadian Association for the Repeal of Abortion Laws (1973–80) </td></tr>
<tr><td valign="top">CARAL </td><td valign="top">Canadian Abortion Rights Action League (1980–2002) </td></tr>
<tr><td valign="top">CBA </td><td valign="top">Canadian Bar Association </td></tr>
<tr><td valign="top">CCTA </td><td valign="top">California Committee on Therapeutic Abortion </td></tr>
<tr><td valign="top">CLSC </td><td valign="top">centre local de services communitaires </td></tr>
<tr><td valign="top">CMA </td><td valign="top">Canadian Medical Association </td></tr>
<tr><td valign="top">ERA </td><td valign="top">Equal Rights Amendment (United States) </td></tr>
<tr><td valign="top">FLQ </td><td valign="top">Front de libération du Québec </td></tr>
<tr><td valign="top">FPD </td><td valign="top">Family Planning Division (Canada) </td></tr>
<tr><td valign="top">G8 </td><td valign="top">Group of Eight </td></tr>
<tr><td valign="top">GOP </td><td valign="top">Republican Party (“Grand Old Party”) </td></tr>
<tr><td valign="top">GP </td><td valign="top">general practitioner </td></tr>
<tr><td valign="top">ICMCA </td><td valign="top">Illinois Citizens for the Medical Control of Abortion </td></tr>
<tr><td valign="top">LARC </td><td valign="top">Labour Abortion Rights Committee (Britain) </td></tr>
<tr><td valign="top">LPAS </td><td valign="top">London Pregnancy Advisory Service </td></tr>
<tr><td valign="top">NAC </td><td valign="top">National Abortion Campaign (Britain) </td></tr>
<tr><td valign="top"><span id="page_viii">NAF </span></td><td valign="top">National Abortion Federation (United States) </td></tr>
<tr><td valign="top">NARAL </td><td valign="top">National Association for the Repeal of Abortion Laws (United States, 1969–73) </td></tr>
<tr><td valign="top">NARAL </td><td valign="top">National Abortion Rights Action League (United States, 1973–present) </td></tr>
<tr><td valign="top">NCCB </td><td valign="top">National Conference of Catholic Bishops (United States) </td></tr>
<tr><td valign="top">NDP </td><td valign="top">New Democratic Party (Canada) </td></tr>
<tr><td valign="top">NHS </td><td valign="top">National Health Service (Britain) </td></tr>
<tr><td valign="top">NORC </td><td valign="top">National Opinion Research Center </td></tr>
<tr><td valign="top">NOW </td><td valign="top">National Organization for Women (United States) </td></tr>
<tr><td valign="top">NRLC </td><td valign="top">National Right to Life Committee (United States) </td></tr>
<tr><td valign="top">NWPC </td><td valign="top">National Women’s Political Caucus (United States) </td></tr>
<tr><td valign="top">OB/GYN </td><td valign="top">obstetrician/gynecologist </td></tr>
<tr><td valign="top">OECD </td><td valign="top">Organisation for Economic Co-operation and Development </td></tr>
<tr><td valign="top">OMA </td><td valign="top">Ontario Medical Association </td></tr>
<tr><td valign="top">PCP </td><td valign="top">primary care practitioner </td></tr>
<tr><td valign="top">PLP </td><td valign="top">Parliamentary Labour Party (Britain) </td></tr>
<tr><td valign="top">PPFA </td><td valign="top">Planned Parenthood Federation of America </td></tr>
<tr><td valign="top">PQ </td><td valign="top">Parti Québécois </td></tr>
<tr><td valign="top">RCOG </td><td valign="top">Royal College of Obstetricians and Gynaecologists (Britain) </td></tr>
<tr><td valign="top">SPUC </td><td valign="top">Society for the Protection of Unborn Children (Britain) </td></tr>
<tr><td valign="top">ZPG </td><td valign="top">Zero Population Growth (United States) </td></tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_List_of.vue?40b5ec8f